import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { restoreUser, setAuthLoading, loggedService, loggedWedding } from './store/userSlice';
import { wakeUpServer } from './store/serverSlice';

import ServerWakeUp from './components/ServerWakeUp';
import ScrollToTop from './components/ScrollToTop';
import axios from 'axios';
import Cookies from 'js-cookie';
import UserService from './services/userService';
import GuestService from './services/guestService';
import { restoreGuest, setAuthLoadingGuest } from './store/guestSlice';

axios.defaults.baseURL = 'https://project-wh-server.onrender.com/api';
// axios.defaults.baseURL = 'http://localhost:4000/api';

axios.interceptors.request.use((config) => {
    const token = Cookies.get('authToken');
    const gToken = Cookies.get('gAuthToken');

    if (gToken) {
        config.headers.authorization = gToken;
    }
    if (token) {
        config.headers.authorization = token;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

function App() {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const refreshDataGuest = useSelector((state) => state.guestStore.refreshData);
    const refreshDataUserService = useSelector((state) => state.userStore.refreshDataUserService);
    const serverStatus = useSelector((state) => state.serverStore.status);

    // Budi server odmah pri ulasku, javne stranice se prikazuju bez čekanja
    useEffect(() => {
        dispatch(wakeUpServer());
    }, [dispatch]);

    useEffect(() => {
        const token = Cookies.get('authToken');
        if (token) {
            if (serverStatus !== 'ready') return;
            UserService.getLoggedUser()
                .then((res) => {
                    // console.log(res.data);
                    dispatch(restoreUser(res.data.user));
                    dispatch(loggedService(res.data.service || null));
                    dispatch(loggedWedding(res.data.wedding || null));
                })
                .catch((err) => {
                    //console.log(err);
                    dispatch(setAuthLoading(false));
                    Cookies.remove('authToken');
                    navigate('/login');
                });
        } else {
            dispatch(setAuthLoading(false));
        }

    }, [dispatch, pathname, refreshDataUserService, serverStatus]);

    useEffect(() => {
        const gToken = Cookies.get('gAuthToken');
        if (gToken) {
            if (serverStatus !== 'ready') return;
            GuestService.getLoggedGuest()
                .then((res) => {
                    // console.log(res.data);
                    dispatch(restoreGuest(res.data));
                })
                .catch((err) => {
                    //console.log(err);
                    dispatch(setAuthLoadingGuest(false));
                    Cookies.remove('gAuthToken');
                    // navigate('/login');
                });
        } else {
            dispatch(setAuthLoadingGuest(false));
        }

    }, [dispatch, pathname, refreshDataGuest, serverStatus]);

    // Logirani korisnik čeka da se server pokrene prije nego vidi aplikaciju
    const waitForServer = serverStatus !== 'ready' && Cookies.get('authToken');

    return (
        waitForServer
            ? <ServerWakeUp />
            :
            <div className="App">
                <Outlet />
                <ScrollToTop />
            </div>
    );
}

export default App;
